import { Component, EventEmitter, Inject, Input, LOCALE_ID, OnChanges, OnInit, Output, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { Subject } from 'rxjs/internal/Subject';
import { CalendarDateFormatter, CalendarEvent, CalendarView, DateAdapter } from 'angular-calendar';
import { CustomDateFormatter } from './custom-date-formatter.provider';
import { isSameDay, isSameMonth } from 'date-fns';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-calendar-schedule',
    templateUrl: './calendar-schedule.component.html',
    styleUrls: ['./calendar-schedule.component.css'],
    encapsulation: ViewEncapsulation.None,
    providers: [{
            provide: CalendarDateFormatter,
            useClass: CustomDateFormatter,
        }],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CalendarScheduleComponent implements OnInit, OnChanges {

    constructor(
        @Inject(LOCALE_ID) locale: string,
        private dateAdapter: DateAdapter,
        private datePipe: DatePipe
    ) {
        this.locale = locale;
    }

    public CalendarView = CalendarView;
    public view: CalendarView = CalendarView.Week;
    public refresh: Subject<any> = new Subject();
    public locale: string = 'pt';
    public hourSegments: number = 2;
    public weekStartsOn: number = 0;
    public excludeDays: number[] = []; // [0];
    public weekendDays: number[] = [0,6];
    public dayStartHour: number = 0;
    public dayEndHour: number = 24;
    public prevBtnDisabled: boolean = false;
    public nextBtnDisabled: boolean = false;
    public activeDayIsOpen: boolean = true;

    @Input() events: CalendarEvent[];
    @Input() minDate: Date;
    @Input() maxDate: Date;
    // Inputs mantidos por compatibilidade com os consumidores: eram conceitos do
    // angular-calendar-scheduler (removido) e não têm efeito nas views nativas
    @Input() startsWithToday: boolean;
    @Input() isMedicalScheduleComponent: boolean = false;
    @Input() showStatusSubtitle: boolean = false;
    @Input() canChangeView: boolean = false;
    @Input() viewSchedulerType: boolean = true;
    @Input() viewDate: Date;
    @Output() newEvent = new EventEmitter<any>();
    @Output() clicked = new EventEmitter<any>();

    ngOnInit(): void {
        this.refresh.next;
    }

    ngOnChanges(): void {
        this.applyEventValidity();
    }

    /**
     * Replica o eventModifier do antigo angular-calendar-scheduler: eventos fora
     * do intervalo [minDate, maxDate] ficam desabilitados (sem clique, esmaecidos).
     * Na agenda médica a referência é o fim do evento; nas demais, o início.
     */
    private applyEventValidity(): void {
        if (!this.events || !this.minDate || !this.maxDate)
            return;

        this.events.forEach((event) => {
            let referenceDate = this.isMedicalScheduleComponent ? (event.end ? event.end : event.start) : event.start;
            if (!this.isDateValid(referenceDate)) {
                event.meta = { ...(event.meta || {}), disabled: true };
                if (!event.cssClass || event.cssClass.indexOf('cal-event-disabled') === -1)
                    event.cssClass = (event.cssClass ? event.cssClass + ' ' : '') + 'cal-event-disabled';
            }
        });
    }

    private isDateValid(date: Date): boolean {
        return date >= this.minDate && date <= this.maxDate;
    }

    addNewEvents(buttonBack: boolean, buttonNext: boolean) {
        this.newEvent.emit({
            viewDate: this.viewDate,
            buttonBack: buttonBack,
            buttonNext: buttonNext
        });
    }

    eventClicked(event: CalendarEvent): void {
        if (event.meta?.disabled)
            return;

        this.clicked.emit(event);
    }

    setView(view: CalendarView) {
        this.view = view;
    }

    dayClicked({ date, events }: { date: Date; events: CalendarEvent[] }): void {
        if (isSameMonth(date, this.viewDate)) {
            if (
            (isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) ||
            events.length === 0
            ) {
            this.activeDayIsOpen = false;
            } else {
            this.activeDayIsOpen = true;
            }
            this.viewDate = date;
        }
    }

    closeOpenMonthViewDay() {
        this.activeDayIsOpen = false;
    }

}
